<template>
  <div>
    <div class="content">
        <div class="content-main">
          <p class="content-title">邀请码搜索</p>
          <div class="content-input">
            <div class="content-input-item">
              <el-input v-model="inviteCode" placeholder="请输入邀请码" style="margin-right: 16px;" clearable>
                <template #prefix>
                  <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
                </template>
              </el-input>
              <el-button type="primary" @click="getPage()" v-loading="loading">查询</el-button>
            </div>
          </div>
        </div>
      <div class="content-main" style="min-height: 60vh;">
        <div class="content-table">
          <el-tree
              :data="pageDataList"
              :props="defaultProps"
              node-key="id"
              default-expand-all
              :expand-on-click-node="false"
              :indent="64"
          >
            <template #default="{ node, data }">
              <div class="tree-slot-main">
                <div class="tree-slot-main-left">
                  <el-image class="tree-slot-main-img" :src="data.headImgSmall"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                  <div class="tree-slot-main-info">
                    <p>昵称：{{ data.nickName }}</p>
                    <p>UID：{{ data.uid }}</p>
                    <p>邀请码：{{ data.inviteCode }}</p>
                    <p>封号状态：<span :style="{ color: data.isForbidden?'red':''}">{{ data.isForbidden?'已封号':'未封号'}}</span></p>
                  </div>
                </div>
                <div class="tree-slot-main-btn">
                  <el-button v-if="!data.noFather && node.level == 1" type="primary" size="small" @click="getPage(data)">上一级</el-button>
                  <el-button v-if="data.subordinateNum > 0 && node.level != 1" type="primary" size="small" @click="getChildren(data)">下一级</el-button>
                  <el-button v-if="!data.isForbidden" type="danger" size="small" @click="updateUserForbidden(data, 1)" v-loading="data['forbiddenLoading']">封号</el-button>
                  <el-button v-if="data.isForbidden" type="warning" size="small" @click="updateUserForbidden(data, 0)" v-loading="data['forbiddenLoading']">解除封号</el-button>
                  <el-button type="success" size="small" @click="getLog(data.id)">用户日志</el-button>
                </div>
                <div class="tree-slot-main-right-log">
                  {{data.userLog}}
                </div>
              </div>
            </template>
          </el-tree>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData, deleteFormData } from "@/api/api";
import {inviteCodeSearch, inviteCodeSearchSubordinate, updateForbiddenState} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ForbiddenDialog from "@/components/resume/ForbiddenDialog";
// import BtnGroup from "@/components/BtnGroup";

export default {
  name: "InviteSearch",
  components: { },
  data() {
    return {
      pageDataList: [],
      loading: false,
      //刷新组
      colList: ['头像', '信息', '操作', '用户日志'],
      checkColList: [],
      inviteCode: '',
      defaultProps: {
        children: 'children',
        label: 'nickName',
        class: 'customClass'
      },
    }
  },
  methods: {
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    toggleRowExpansion(row, column, event) {
      if(column.label != '操作') {
        this.$refs.multipleTableRef.toggleRowExpansion(row)
      }
    },

    getPage(obj) {
      let inviteCode = obj ? obj.inviteCode : this.inviteCode;
      if(!inviteCode) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入邀请码',
          type: 'warning'
        })
        return;
      }
      this.loading = true
      getFormData(inviteCodeSearch, {inviteCode: inviteCode}).then((data)=>{
        let {msg, code} = data
        if (code == 200) {
          let dataList = data.data
          if(dataList.superiorUser) {
            dataList.user.children = dataList.subordinateUserList;
            dataList.superiorUser.children = [dataList.user];
            this.pageDataList = [dataList.superiorUser];
          } else {
            dataList.user.children = dataList.subordinateUserList;
            dataList.user.noFather = true;
            this.pageDataList = [dataList.user];
          }
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 1000,
          })
        }
        this.loading = false
      }).catch((err) => {
        this.loading = false
        this.$message({
          message: err.msg,
          type: 'warning',
          duration: 1000
        })
      })
    },

    getChildren(obj) {
      this.loading = true;
      getFormData(inviteCodeSearchSubordinate, {inviteCode: obj.inviteCode}).then((data) => {
        if(data.code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'success'
          })
          obj.children = data.data;
          this.$set(obj)
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'warning'
          })
        }
        this.loading = false;
      })
          .catch(() => {
            this.loading = false;
          })
    },

    //更新封号
    updateUserForbidden(row, state) {
      let arr = []
      arr.push(row.id)
      if(state == 1) {
        Dialog.open({
          title: '确定对用户【' + row.nickName + '】封号？',
          component: ForbiddenDialog,
          data: {
            idArray: arr,
            width: '500px'
          },
          confirm: () => {
            row['isForbidden'] = true
          }
        })
      } else if(state == 0) {
        this.$confirm('确定【取消封号】用户' +'【' + row.nickName + '】?').then(()=>{
          row['forbiddenLoading'] = true
          let param = {}
          param['idArr'] = arr
          param['forbiddenState'] = state
          param['idfaBanState'] = 0
          postFormData(updateForbiddenState, param).then((data)=>{
            let {code, msg} = data
            if(code == 200) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
              row['isForbidden'] = false
            }else {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            row['forbiddenLoading'] = false
          }).catch(()=>{
            row['forbiddenLoading'] = false
          })
        })
      }
    },

    getLog(id) {
      Dialog.open({
        title: '用户日志',
        component: UserLogDialog,
        data: {
          id: id
        },
        close: () => {
          this.getPage()
        }
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    // this.getPage();
  }
}
</script>

<style>

.tree-slot-main {
  display: flex;
  align-items: center;
  border-left: 1px #ebeef5 solid;
  justify-content: space-between;
  height: 100px;
  width: 100%;
  border-bottom: 1px #ebeef5 solid;
}

.tree-slot-main-left {
  display: flex;
  align-items: center;
}

.tree-slot-main-btn {
}

.tree-slot-main-right-log {
  width: 300px;
  margin-left: 24px;
  white-space: normal;
}

.tree-slot-main-img {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin:  0 16px 0 24px;
}

.tree-slot-main-info {
  font-size: 12px;
}

.customClass > .el-tree-node__content {
  height: 100px;
}

</style>
